import React from 'react';

const KitchenPlaceholder = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={108} height={69} fill="none" {...props}>
    <rect width={43.5} height={4.5} x={15.25} y={3.25} fill="#EBEBEB" stroke="#959595" strokeWidth={0.5} rx={0.75} />
    <path fill="#D9D9D9" d="M40.042 53.34h16.575v9.596H40.042z" />
    <rect width={8.723} height={8.723} x={70.575} y={33.277} fill="#E5E5E5" stroke="#959595" rx={1} />
    <rect
      width={2.617}
      height={5.583}
      x={81.915}
      y={33.015}
      fill="#D9D9D9"
      stroke="#959595"
      strokeWidth={0.6}
      rx={0.4}
    />
    <rect
      width={2.617}
      height={2.966}
      x={81.915}
      y={39.383}
      fill="#D9D9D9"
      stroke="#959595"
      strokeWidth={0.6}
      rx={0.4}
    />
    <circle cx={40.915} cy={26.298} r={1.245} fill="#fff" stroke="#959595" />
    <circle cx={53.128} cy={26.298} r={1.245} fill="#fff" stroke="#959595" />
    <path fill="#EAEAEA" stroke="#959595" d="M63.223 2.372h12.085v15.575H63.223zM78.925 2.372h13.83v15.575h-13.83z" />
    <path
      fill="#959595"
      d="M77.1 36.953c0-.168-.11-.28-.279-.28h-3.688c-.168 0-.28.112-.28.28 0 1.285.615 2.347 1.454 2.682H71.68v.503h6.65v-.503h-2.682c.838-.335 1.453-1.397 1.453-2.682Zm-3.688.28h3.13c-.112 1.173-.727 2.067-1.565 2.067-.782 0-1.453-.894-1.565-2.068Z"
    />
    <path
      fill="#959595"
      d="M84.59 31.532H70.561c-.95 0-1.732.782-1.732 1.732v8.886c0 .894.615 1.62 1.453 1.733v1.62h.503v-1.62H84.31v1.62h.503v-1.62c.838-.112 1.453-.839 1.453-1.733v-8.886c.112-.95-.67-1.732-1.677-1.732Zm-14.016 11.34c-.67 0-.872-.051-.872-.722v-8.873c0-.671.202-.873.873-.873H80.606v10.468H70.575Zm14.83-.722c0 .67-.201.722-.872.722H81.18V32.404h3.352c.67 0 .872.202.872.872v8.874ZM31.755 68.17H16.202C14.472 68.17 13 66.256 13 63.9V32.251c0-2.357 1.36-4.208 3.09-4.208h16.692c1.73 0 3.09 1.851 3.09 4.208v31.648c0 2.357-1.47 4.271-3.202 4.271h-.915ZM14.49 43.53a.5.5 0 0 0-.5.5v20.037c0 1.515.865 2.862 2.102 2.862h16.69c1.113 0 2.102-1.347 2.102-2.862V44.03a.5.5 0 0 0-.5-.5H14.49Zm-.5-1.847a.5.5 0 0 0 .5.5h19.77a.5.5 0 0 0 .5-.5v-9.432c0-1.515-.865-2.862-2.101-2.862H16.09c-1.113 0-2.102 1.347-2.102 2.862v9.432Zm3.833 13.81a.495.495 0 0 1-.99 0v-9.617a.495.495 0 1 1 .99 0v9.617Zm0-17.508a.495.495 0 0 1-.99 0v-4.398a.495.495 0 0 1 .99 0v4.398ZM55.773 51.306c.753 0 1.413-.66 1.413-1.413 0-.754-.66-1.413-1.413-1.413-.754 0-1.414.66-1.414 1.413 0 .754.66 1.413 1.414 1.413Zm0-1.978c.282 0 .565.282.565.66 0 .376-.283.564-.565.564-.283 0-.566-.282-.566-.565s.189-.66.566-.66Z"
    />
    <path
      fill="#959595"
      d="M59.73 47.35a.405.405 0 0 0 .376-.378v-1.978a.405.405 0 0 0-.377-.377H36.93a.405.405 0 0 0-.377.377v1.978c0 .189.189.377.377.377h.565v17.053h-.565a.405.405 0 0 0-.377.376v3.015c0 .189.189.377.377.377h22.8a.405.405 0 0 0 .376-.377v-3.015a.405.405 0 0 0-.377-.376h-.565V47.349h.566Zm-22.423-1.98h21.951v1.225H37.306v-1.224Zm22.046 19.785v2.167H37.307v-2.167h22.046Zm-1.037-.753H38.343V47.349h19.973v17.053Z"
    />
    <path
      fill="#959595"
      d="M39.945 63.177h16.864a.405.405 0 0 0 .377-.377v-9.892a.405.405 0 0 0-.377-.377H39.945a.405.405 0 0 0-.377.377V62.8c0 .283.094.377.377.377Zm.377-9.892h16.016v9.138H40.322v-9.139Z"
    />
    <path
      fill="#959595"
      d="M53.794 55.546H42.865a.405.405 0 0 0-.376.377c0 .188.188.376.376.376h10.93a.405.405 0 0 0 .376-.377c0-.282-.188-.376-.377-.376ZM39.945 51.306H48.8a.405.405 0 0 0 .377-.377v-1.978a.405.405 0 0 0-.377-.377h-8.856a.405.405 0 0 0-.377.377v1.978c0 .283.094.377.377.377Zm.377-1.978h8.102v1.224h-8.102v-1.224ZM51.816 51.306c.753 0 1.413-.66 1.413-1.413 0-.754-.66-1.32-1.413-1.32-.754 0-1.413.66-1.413 1.414 0 .754.659 1.32 1.413 1.32Zm0-1.978c.282 0 .565.282.565.565 0 .282-.283.565-.565.565-.283 0-.566-.282-.566-.565s.189-.565.566-.565Z"
    />
    <rect width={15.575} height={21.681} x={62.351} y={45.989} fill="#EAEAEA" stroke="#959595" rx={0.5} />
    <path
      fill="#EAEAEA"
      stroke="#959595"
      d="M78.053 46.49a.5.5 0 0 1 .5-.5h13.702a.5.5 0 0 1 .5.5v20.68a.5.5 0 0 1-.5.5H78.053V46.49Z"
    />
    <path stroke="#959595" strokeLinecap="round" strokeWidth={2} d="M61.979 45.362H94" />
    <path
      stroke="#959595"
      strokeLinecap="round"
      d="M75.372 54.213v2.617M81.043 54.213v2.617M80.17 8.851v2.617M64.468 8.851v2.617"
    />
    <path
      stroke="#959595"
      d="M93.564 1H14a1 1 0 0 0-1 1v7.16a1 1 0 0 0 1 1h46.415a1 1 0 0 1 1 1v7.595a1 1 0 0 0 1 1h31.149a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1Z"
    />
    <path
      fill="#D9D9D9"
      stroke="#959595"
      d="M39.063 20.958a.5.5 0 0 1 .442-.266h2.451a.5.5 0 0 1 .43.244l2.437 4.107a.5.5 0 0 1-.43.755h-7.054a.5.5 0 0 1-.442-.733l2.166-4.107Z"
    />
    <path stroke="#959595" strokeLinecap="round" d="M40.74 20.192v-9.596" />
    <path
      fill="#D9D9D9"
      stroke="#959595"
      d="M51.275 20.958a.5.5 0 0 1 .443-.266h2.45a.5.5 0 0 1 .43.244l2.438 4.107a.5.5 0 0 1-.43.755h-7.054a.5.5 0 0 1-.443-.733l2.166-4.107Z"
    />
    <path stroke="#959595" strokeLinecap="round" d="M52.953 20.192v-9.596" />
    <path stroke="#959595" d="M77.181 1v19.192M61.479.999v18.205" />
    <path
      fill="#D9D9D9"
      d="M47.021 39.993h9.596-9.596Zm.96 0 .242 2.418c.113 1.13.169 1.696.582 2.038.412.343 1.036.343 2.284.343h1.46c1.248 0 1.873 0 2.285-.343.412-.342.468-.907.582-2.038l.241-2.418m-7.676-.872 2.399-.589-2.4.59Zm2.399-.589 2.878-.707-2.878.707Zm0 0 .099-.758a.652.652 0 0 1 .175-.366.761.761 0 0 1 .372-.213l.944-.232a.814.814 0 0 1 .437.015c.141.045.264.127.353.236l.498.611m0 0 2.4-.589-2.4.59Z"
    />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M47.021 39.993h9.596m-8.636 0 .242 2.418c.113 1.13.169 1.696.582 2.038.412.343 1.036.343 2.284.343h1.46c1.248 0 1.873 0 2.285-.343.412-.342.468-.907.582-2.038l.241-2.418m-7.676-.872 2.399-.589m0 0 2.878-.707m-2.878.707.099-.758a.652.652 0 0 1 .175-.366.761.761 0 0 1 .372-.213l.944-.232a.814.814 0 0 1 .437.015c.141.045.264.127.353.236l.498.611m0 0 2.4-.589"
    />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M1 68h106"
    />
  </svg>
);

export default KitchenPlaceholder;
